import { withCompInfo } from '@wix/editor-elements-integrations'
import { colorApi } from '@wix/thunderbolt-becky-root'
import type { ScreenWidthContainerCss, ScreenWidthContainerDefinition } from './ScreenWidthContainer'

export const css = withCompInfo<ScreenWidthContainerCss, ScreenWidthContainerDefinition>()(
	['styleProperties', 'siteColors'],
	({ styleProperties, siteColors }) => {
		const brightnessParams = colorApi.getBrightnessCSSVars({
			styleProperties,
			siteColors,
		})

		return { ...brightnessParams, width: '100%', left: 0, 'margin-left': 0 }
	}
)
